import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { ActionPanelContext, DetailsPanelContext } from '../../../../../../components/layout/rightPanels'
import { PANEL_TYPE } from '../../../utils/constant'
import { selectAssolement } from '../../assolement/assolementAction'

/**
 * Injecteur pour l'ouverture du panel de détail de culture
 */
export const openCultureDetail = (WrappedComponent) => {
	const OpenCultureDetailInjector = ({ selectAssolement, ...props }) => {
		const { openPanel: openPanelDetail, closePanel: closePanelDetail } = React.useContext(DetailsPanelContext)
		const { closePanel: closePanelAction} = React.useContext(ActionPanelContext)

		const openCultureDetail = (assolement) => {
			closePanelAction()
			openPanelDetail()
			selectAssolement(assolement, PANEL_TYPE.CULTURE_DETAIL)
		}

		const closeCultureDetail = () => {
			closePanelDetail()
		}

		return <WrappedComponent
			{...props}
			openCultureDetail={React.useCallback(openCultureDetail, [])}
			closeCultureDetail={React.useCallback(closeCultureDetail, [])}
		/>
	}

	const actions = {
		selectAssolement
	}

	OpenCultureDetailInjector.propTypes = {
		selectAssolement: PropTypes.func
	}

	return connect(undefined, actions)(OpenCultureDetailInjector)
}
